export const ADD = "Add";
export const DELETE = "Delete";
export const DELETE_CONFIRMATION_TEXT =
	"Are you sure you want to delete record(s)";
export const CANCEL = "Cancel";
export const DELETE_CONFIRMATION_TEXT_FOR_SINGLE_RECORD =
	"Are you sure you want to delete record?";
